(function ($, Cobalt, global, undefined) {
    Cobalt.Advertising = {
        processAds: function () {
            $(document).ready(function () {
                Cobalt.Advertising.onLoaded();
            });
        },
        onLoaded: function () {
            $(".queued-ad").each(function () {
                var $ad = $(this);
                $ad.removeClass("queued-ad");
                var actualID = $ad.attr("data-related-ad");
                var html = $ad[0].innerHTML;
                $ad.remove();
                $("#" + actualID)[0].innerHTML = html;
            });
        }
    };

    global.bodyClick = function bodyClick(url, toggleHeaderOn) {
        // Extends clickable area of BODY-tag not only to initial viewport render
        // However, #page gets needs to inherit min-height and height of BODY-tag        
        $('body').css({ 'min-height': '100%', 'height': 'auto', 'cursor': 'pointer' }).addClass('ad-skin');
        $('#page').css({ 'min-height': '100%', 'height': 'auto', 'cursor': 'pointer' });
        $('#content').css({ 'cursor': 'default' });
        $('#header').css('cursor', 'pointer');
        $('#header div.hdbox').css('cursor', 'default');
        $('body').click(function (e) {
            var obj = (e.target ? e.target : e.srcElement);            
            if (obj.nodeName != 'BODY' && obj.id != "site") return true;
            window.open(url);
            return false;
        });
        if (toggleHeaderOn == "1") {
            $('#header').click(function (e) {
                var obj = (e.target ? e.target : e.srcElement);
                if (obj.id != 'header') return true;
                window.open(url);
                return false;
            });
        }
    };
})(jQuery, Cobalt, window || this);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Advertising.js